module.exports = __webpack_public_path__ + "static/media/slide_03.604e2e38.jpg";